import * as React from 'react';
import { HashRouter, Redirect, Route, RouteComponentProps } from 'react-router-dom';
import * as _ from 'underscore';

import { connect } from 'react-redux';
import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { selectPreviousUrl } from '../../selectors/NavigationStateSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { WorkbookSubspaceName } from '../../state/SpaceInfo';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { TableauReactRouterSwitch } from '../RouterHelpers/TableauReactRouterSwitch';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { WorkbookSpaceProvider } from './WorkbookSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}

export interface WorkbookRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface WorkbookSpaceRouterOwnProps extends ReactDirectiveProps {}

export interface WorkbookSpaceRouterStateProps {
  readonly urls: SpacesSiteUrls;
  readonly previousUrl: string;
  readonly catalogingOnSiteEnabled: boolean;
}

export type WorkbookSpaceRouterProps = WorkbookRouteComponentProps & WorkbookSpaceRouterOwnProps & WorkbookSpaceRouterStateProps;

export class WorkookSpaceRouterComponent extends React.PureComponent<WorkbookSpaceRouterProps> {
  public render() {
    return (
      <HashRouter>
        <TableauReactRouterSwitch baseUrl={this.props.urls.workbookPath('')}>
          <Route exact path={this.props.urls.workbookViewsPath(':id')} render={this.provider('views')} />
          <Route exact path={this.props.urls.workbookDatasourcesPath(':id')} render={this.provider('datasources')} />
          <Route exact path={this.props.urls.workbookSubscriptionsPath(':id')} render={this.provider('subscriptions')} />
          <Route exact path={this.props.urls.workbookExtractRefreshesPath(':id')} render={this.provider('extractTasks')} />
          { this.props.catalogingOnSiteEnabled && <Route path={this.props.urls.workbookLineagePath(':id')} render={this.provider('lineage')} /> }
          <Route exact path={this.props.urls.workbookPublishresultPath(':id')} render={({ match }) => (
            <Redirect to={this.props.urls.workbookViewsPath(match.params.id)} />
          )} />
          <Route exact path={this.props.urls.workbookDetailsPath(':id')} render={({ match }) => (
            <Redirect to={this.props.urls.workbookViewsPath(match.params.id)} />
          )} />
          <Route exact path={this.props.urls.workbookPath(':id')} render={({ match }) => (
            <Redirect to={this.props.urls.workbookViewsPath(match.params.id)} />
          )} />
          <Route render={this.error} />
        </TableauReactRouterSwitch>
      </HashRouter>
    );
  }

  private provider = (subspaceName: WorkbookSubspaceName): (props: WorkbookRouteComponentProps) => JSX.Element => {
    return (props: WorkbookRouteComponentProps): JSX.Element => {
      const workbookId = props.match.params.id;
      const publishResult = {
        display: this.props.previousUrl.includes(this.props.urls.workbookPublishresultPath(workbookId)),
        resultUrl: this.props.previousUrl
      };
      return <WorkbookSpaceProvider {...{...this.props, routeLocationPath: props.location.pathname, subspaceName, publishResult, routeLocationSearch: props.location.search, workbookId}} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}

const mapStateToProps: MapStateToProps<WorkbookSpaceRouterStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  previousUrl: selectPreviousUrl(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

export const WorkbookSpaceRouter: React.ComponentClass<WorkbookSpaceRouterOwnProps>
  = connect(mapStateToProps)(WorkookSpaceRouterComponent);
